import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { filterItems } from '../Filter/constants';
import { getAdasisResponse, getEnhancedData } from '../../service/Api';

import turf from 'turf';

import { xor } from 'lodash';

const emptyGeojson = { type: "FeatureCollection", features: [] };
const emptyData = { adasis: emptyGeojson, geojson: emptyGeojson, mpp: emptyGeojson };

const initialState = {
    data: emptyData,
    status: 'none',
    filter: ['SpeedLimits', 'Curvatures', 'Slopes'],
    mode: 'EnhancedData',
    sliderValue: 1,
    bbox: undefined
};

const getBbox = (features) => {
  const points = features.reduce((res, f) => {
    const coords = f.geometry.type === 'Point' ? [f.geometry.coordinates] : f.geometry.coordinates;
    return [...res, ...coords.filter(c => c[0] !== null && c[1] != null)];
  }, [])

  return turf.bbox(turf.lineString(points));
}

export const setDataAsync = createAsyncThunk(
    'EnhancedData/getEnhancedData',
    async (mode) => {
      const response = mode !== 'Adasis' ? await getEnhancedData() : await getAdasisResponse();
      const property = mode !== 'Adasis' ? 'geojson' : 'adasis';
      
      const features = mode !== 'Adasis' ? response.data.features.filter(f => f.properties.type === 'SpeedLimit').filter((_, idx) => idx % 20 === 0) : response.data.features;
      const bbox = getBbox(features);

      return { data: response.data, property, bbox };
    }
);

export const mapDataSlice = createSlice({
    name: 'MapData',
    initialState,
    reducers: {
        clearData: (state) => {
            state.data = emptyData;
        },
        setData: (state, action) => {
          state.data.geojson = action.payload.data;
        },
        setSliderValue: (state, action) => {
          if (!action.payload) {
            state.sliderValue = state.sliderValue + 1;
          } else {
            state.sliderValue = action.payload;
          }
        },
        setAdasisData: (state, action) => {
          state.data.adasis = action.payload.data;
        },
        setFilter: (state, action) => {
            if (action.payload === 'Select All Data') {
              state.filter = state.filter.length < filterItems[state.mode].length ? filterItems[state.mode].map(item => item.value) : [];
            } else {
              state.filter = xor(state.filter, [action.payload]);
            }
        },
        setMode: (state, action) => {
          const mode = action.payload;
          state.filter = filterItems[mode].map(item => item.value);
          state.mode = mode;
        },
        completeStatus: (state) => {
          if (state.status === 'idle') {
            state.status = 'completed';
          }
        }
    },
    extraReducers: (builder) => {
      builder
        .addCase(setDataAsync.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(setDataAsync.fulfilled, (state, action) => {
          state.status = 'idle';
          state.data[action.payload.property] = action.payload.data;
          state.bbox = action.payload.bbox;
        });
    },
});

export const { clearData, setFilter, setData, setMode, setAdasisData, setSliderValue, completeStatus } = mapDataSlice.actions;

export default mapDataSlice.reducer;